export default {
  pageTitle: "Receipt Forwarding",
  menuLabel: "Receipt Forwarding",
  locked: {
    title: "Receipt Forwarding",
    description:
      "Forward receipts from your email to automatically create draft expenses. Available on the Pro plan.",
    benefitAuto: "Automatic draft expenses from forwarded receipts",
    benefitAttachments: "Attachments stored and ready for review",
    benefitSimple:
      "Simple workflow — forward from your phone or desktop email client",
    cta: "Upgrade to Pro",
  },
  address: {
    label: "Your inbound address",
    copyTooltip: "Copy to clipboard",
    copiedTooltip: "Copied",
  },
  explainer:
    "Forward receipts from your invup team members. Forwards from other addresses won't be processed.",
  howItWorks:
    "On your phone: take a photo of the receipt, attach it to a new email to this address, and send. We'll create a draft expense for you to review.",
  noToken:
    "Your inbound address hasn't been generated yet. Click below to create one.",
  generateButton: "Generate inbound address",
  sendTest: "Send a test",
  rotate: {
    button: "Rotate token",
    modalTitle: "Rotate inbound address?",
    modalMessage:
      "Anyone forwarding to your old address will silently fail. Make sure to update saved contacts after rotating.",
    confirmButton: "Rotate",
  },
};
